<div>
   <div *ngFor="let usedShortCut of usedShortCuts$ | async">
      <span
         [innerHtml]="
            'navigation.hotkey_duplication.warning'
               | translate: { shortcut: eventShortcutString, function: usedShortCut.translationKey | translate }
               | safeHtml
         "
      >
      </span>
   </div>

   <div fxLayout="column" class="container sam-padding">
      <div fxFlex="2" fxLayout="row" fxFlexAlign="end" fxLayoutGap="5px">
         <div class="sam-form-row">
            {{ 'navigation.hotkey_duplication.replace_text' | translate }}
         </div>
         <div class="sam-form-row"></div>

         <button kendoButton [primary]="true" (click)="click()">
            <div class="sam-button-text">
               {{ 'navigation.hotkey_duplication.replace_button' | translate }}
            </div>
         </button>
      </div>
   </div>
</div>
